import styled from "styled-components";
import { Link } from "react-router-dom";

export const StyledLink = styled(Link)`
  display: inline;
  text-decoration: none;
  color: inherit;
  -webkit-tap-highlight-color: transparent;
`;
